import PropTypes from 'prop-types';

export const aiQuestionCardPropTypes = {
  questions: PropTypes.arrayOf(
    PropTypes.shape({
      header: PropTypes.string.isRequired,
      question: PropTypes.string.isRequired,
      multiSelect: PropTypes.bool,
      options: PropTypes.arrayOf(
        PropTypes.shape({
          label: PropTypes.string.isRequired,
          description: PropTypes.string,
        }),
      ),
    }),
  ).isRequired,
  onSubmit: PropTypes.func.isRequired,
  onDismiss: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool,
};
